module.exports = __webpack_public_path__ + "img/12-hehku.19d59757.jpg";